/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Expense_Report_Total_IncomeInputs */

const vi_expense_report_total_income = /** @type {(inputs: Expense_Report_Total_IncomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tổng thu`)
};

/**

* @param {Expense_Report_Total_IncomeInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const expense_report_total_income = /** @type {((inputs?: Expense_Report_Total_IncomeInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Expense_Report_Total_IncomeInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_expense_report_total_income(inputs)
});